import React, { useEffect } from "react";
import SEO from "../components/SEO";
import { useNavigate } from "react-router-dom";
import backVideo from "../assets/images/backvideo.mp4";
import "../assets/css/ComingSoon.css";
import ComingsoonFooter from "../components/ComingsoonFooter";

const CommingSoon = () => {
  const navigate = useNavigate();
  const pageUrl = "https://shaadimaterial.com/";
  const pageImage = "https://shaadimaterial.com/logo512.png";



  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Shaadi Material",
    url: pageUrl,
    logo: pageImage,
    description:
      "Shaadi Material — Premium Wedding Design Assets & Templates",
    publisher: {
      "@type": "Organization",
      name: "Shaadi Material",
      logo: {
        "@type": "ImageObject",
        url: pageImage,
      },
    },
  };

    useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/waitlist", { replace: true });
    }, 7500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <SEO
        title="Coming Soon"
        description="Shaadi Material is launching soon with premium wedding invitation templates, monograms, cliparts, logos, illustrations, patterns, and design assets."
        keywords="wedding invitation templates, wedding design assets, wedding clipart, wedding monogram, Shaadi Material"
        canonical={pageUrl}
        image={pageImage}
        type="website"
        jsonLd={jsonLd}
      />

      <section className="video-wrapper">
        <video autoPlay loop muted playsInline className="bg-video">
          <source src={backVideo} type="video/mp4" />
        </video>

        <div className="video-container">
          <ComingsoonFooter />
        </div>
      </section>
    </>
  );
};

export default CommingSoon;